import React, { useState } from "react";
import { Facebook, Twitter, Linkedin } from "lucide-react"; // اضافه کردن آیکون‌ها

// Image imports
import product16 from "../../assets/images/people/ArminRashnoo.jpg";
import product17 from "../../assets/images/people/FatemehAzizi.jpg";
import product18 from "../../assets/images/people/vahidGhezelvand.jpg";
import product19 from "../../assets/images/people/MojtabaAlizadeh.jpg";
import Saeid from "../../assets/images/people/SaeidRezaei.jpg";
import product20 from "../../assets/images/people/user-profile.png";

const OurProduct = () => {
  const [hoveredMember, setHoveredMember] = useState<number | null>(null);

  const teamMembers = [
    {
      img: Saeid,
      name: "سعید رضایی",
      job: "برنامه نویس (فول استک)",
      jobTitle: "کارشناسی‌  مهندسی کامپیوتر - برنامه نویس تیم هاویر کشت",
      detailedDescription:
        "برنامه‌نویس فول‌استک  با ۴+ سال سابقه در توسعه وب و دسکتاپ. دارنده مدرک کارشناسی مهندسی کامپیوتر و طراح چندین سامانه استانی و ملی در حوزه‌های مختلف از جمله جهاد کشاورزی، آموزش و پرورش و سامانه های تولید دان و جوجه.",
      socialLinks: {
        linkedin: "https://www.linkedin.com/in/saeid-rezaei-frontend",
        website: "https://saeidrezaei.netlify.app/",
        gitHub: "https://github.com/Saeid-Rezaei0",
      },
      mainso: {
        website: "https://saeidrezaei.netlify.app/",
        gitHub: "https://github.com/Saeid-Rezaei0",
      },
    },


    {
      img: product18,
      name: "وحید قزلوند",
      job: "برنامه نویس ارشد",
      jobTitle:
        "کارشناسی‌ ارشد مهندسی کامپیوتر - مدیر تیم برنامه نویسی هاویر کشت",
      detailedDescription:
        "وحید کارشناسی ارشد مهندسی کامپیوتر و برنامه نویس ارشد (Senior) در حوزه وب و دسکتاپ است که 18 سال سابقه برنامه نویسی با تیم‌های مختلف دارد و طراح چندین سامانه استانی و ملی در حوزه‌های مختلف از جمله حوزه جهاد کشاورزی، آموزش و پرورش و دیگر سازمان‌های دولتی است.",
      socialLinks: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
      },
    },
    {
      img: product16,
      name: "آرمین رشنو",
      job: "مدیر پروژه",
      jobTitle: "دکترای مهندسی کامپیوتر - مدیر پروژه هاویر کشت",
      detailedDescription:
        "آرمین دکتری مهندسی کامپیوتر گرایش هوش مصنوعی و عضو هیئت علمی دانشگاه لرستان با مرتبه علمی دانشیار است. در دانشگاه صنعتی اصفهان و دانشگاه ایالتی مینه سوتا آمریکا تحصیل کرده است. آرمین برگزیده بنیاد ملی نخبگان ایران است، چندین اختراع در سطح ملی و بین‌المللی داشته و بیش از 10 پروژه کاربردی را در حوزه‌های مختلف راه‌اندازی کرده است.",
      socialLinks: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
      },
    },
    {
      img: product17,
      name: "فاطمه عزیزی",
      job: "پشتیبان فنی",
      jobTitle: "کارشناسی مهندسی کامپیوتر - پشتیبان فنی هاویر کشت",
      detailedDescription:
        "فاطمه کارشناسی مهندسی کامپیوتر گرایش نرم افزار دارد. در دانشگاه لرستان تحصیل کرده است. حدود 1 سال است که وارد دنیای برنامه نویسی شده است. در حوزه‌های برنامه نویسی سمت کاربر، طراحی و گرافیک علاقمند است و تجربه کار در این حوزه‌ها را دارد.",
      socialLinks: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
      },
    },

    {
      img: product19,
      name: "مجتبی علیزاده",
      job: "امنیت شبکه",
      jobTitle: "دکترای مهندسی کامپیوتر - مدیر تیم امنیت هاویر کشت",
      detailedDescription:
        "مجتبی دکتری مهندسی کامپیوتر گرایش امنیت شبکه و برگزیده بنیاد ملی نخبگان می‌باشد. تجربه تحصیل و پژوهش در کشورهای مالزی و ژاپن را دارد. او همچنین دانش‌آموخته برگزیده سال ۲۰۱۶ مرکز بین‌المللی فناوری ژاپن-مالزی است. هم اکنون عضو هیات علمی دانشگاه لرستان می‌باشد.",
      socialLinks: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
      },
    },
    {
      img: product20,
      name: "محمد امین عادلی",
      job: "برنامه نویس بک اند",
      jobTitle: "   کارشناسی‌ مهندسی کامپیوتر - برنامه نویس  تیم  هاویر کشت",
      detailedDescription:
        "برنامه‌نویس بک اند  توسعه دهنده بک اند وب   . دارنده مدرک کارشناسی مهندسی کامپیوتر و طراح چندین سامانه استانی و ملی در حوزه‌های مختلف از جمله جهاد کشاورزی، آموزش و پرورش و سازمان‌های تولید دان و جوجه.",
      socialLinks: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
      },
    },
  ];

  return (
    <React.Fragment>
      <section className="relative py-5 xl:py-16 bg-[#F4F7FA]" id="membeteam">
        <div className="container 2xl:max-w-[87.5rem] px-4 mx-auto">
          <div className="mx-auto text-center xl:max-w-3xl">
            <h1 className="mb-2 leading-normal capitalize">اعضای تیم ما</h1>
            <h4 className="mb-0 leading-normal text-gray-400 capitalize font-light">
              اعضای تیم طراح سامانه پیمانکاران چغندرقند هاویر - هاویر کشت
            </h4>
          </div>
          <div className="grid grid-cols-1 gap-5 mt-12 md:grid-cols-2 xl:grid-cols-3">
           {teamMembers.map((member, index) => (
              <div
                key={index}
                className="p-6 rounded-2xl bg-gradient-to-br from-white to-green-100 dark:from-zinc-800 dark:to-zinc-900 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-zinc-700"
                data-aos="fade-up"
                data-aos-easing="linear"
                onMouseEnter={() => setHoveredMember(index)}
                onMouseLeave={() => setHoveredMember(null)}
              >
                <div className="relative overflow-hidden group">
                  <img
                    src={member.img}
                    alt={member.name}
                    className="mx-auto h-48 w-48 rounded-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                  />
                  {/* Hover effect */}
                  {hoveredMember === index && (
                    <div className="absolute inset-0 flex items-center justify-center bg-blue-700 bg-opacity-60  rounded-full opacity-100 transition-opacity duration-300">
                      <div className="text-white overflow-hidden text-center space-y-2">
                        <h4 className=" text-lg text-white">{member.name}</h4>
                        <p className="text-[1rem]">{member.job}</p>
                        <div className="flex space-x-3 mt-2">
                          {member.socialLinks.website ? (
                            <>
                              <a
                                target="_blank"
                                href={member.socialLinks.website}
                                className="p-2 rounded-full bg-gray-800 hover:bg-opacity-80 transition-all"
                              >
                                Saeid-Rezaei.ir
                              </a>
                              <a
                                target="_blank"
                                href={member.socialLinks.gitHub}
                                className="p-2 rounded-full bg-gray-800 hover:bg-opacity-80 transition-all"
                              >
                                GitHub
                              </a>
                              <a
                                target="_blank"
                                href={member.socialLinks.linkedin}
                                className="p-2 rounded-full bg-gray-800 hover:bg-opacity-80 transition-all"
                              >
                                Linkedin
                              </a>
                            </>
                          ) : (
                            <>
                              <a
                                href={member.socialLinks.facebook}
                                className="p-2 rounded-full bg-blue-600 hover:bg-opacity-80 transition-all"
                              >
                                <Facebook className="text-white" />
                              </a>
                              <a
                                href={member.socialLinks.twitter}
                                className="p-2 rounded-full bg-blue-600 hover:bg-opacity-80 transition-all"
                              >
                                <Twitter className="text-white" />
                              </a>
                              <a
                                href={member.socialLinks.linkedin}
                                className="p-2 rounded-full bg-blue-600 hover:bg-opacity-80 transition-all"
                              >
                                <Linkedin className="text-white" />
                              </a>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="mt-3 text-center">
                  <h5 className="">
                    {member.name == "سعید رضایی" ? (
                      <a
                        target="_blank"
                        href="https://saeidrezaei.netlify.app/"
                        className="cursor-pointer"
                      >
                        {member.name}
                      </a>
                    ) : (
                      member.name
                    )}
                  </h5>
                  <p className="text-gray-500 py-2 text-[1rem]">
                    {member.jobTitle}
                  </p>
                  <p className="text-gray-500 text-[1rem]">
                    {member.name == "سعید رضایی" ? (
                      <div className="flex flex-col items-center">
                        <a
                          target="_blank"
                          href="https://saeidrezaei.netlify.app/"
                          className=" dark:hover:text-gray-300 transition-colors duration-300 mb-2"
                        >
                          {member.detailedDescription}
                        </a>
                        <a
                          target="_blank"
                          href="https://saeidrezaei.netlify.app/"
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium text-sm transition-colors duration-300 inline-flex items-center"
                        >
                          <span>Saeid-Rezaei.ir</span>
                          <i className="fas fa-external-link-alt mr-1 mx-2 text-xs"></i>
                        </a>
                      </div>
                    ) : (
                      <span className="text-center  text-md rtl  dark:hover:text-gray-100 transition-colors duration-300">
                        {member.detailedDescription}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default OurProduct;
